import {TenantDto} from "../../model/TenantDto";
import {customAxios} from "../customAxios";
import {useEffect, useState} from "react";

export function useGetTenant() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<TenantDto>();
    const [error, setError] = useState<Error>();

    async function execute(id: number) {
        try {
            setLoading(true);
            setError(undefined);
            const data = await getTenant(id);
            setData(data);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, data, error, execute
    };
}

export async function getTenant(id: number): Promise<TenantDto> {
    const response = await customAxios.get<TenantDto>(`/v1/tenant/${id}`, );
    return response.data;
}

